import { z } from 'zod';

/**
 * Per-platform phone number access, controlled by the Central Dashboard.
 * The dashboard replaces the whole allowlist in one call.
 */
export const updatePhoneAccessSchema = z.object({
  enforced: z.boolean(),
  phone_numbers: z.array(z.string().trim().min(1)).max(5000),
});

export type UpdatePhoneAccessDto = z.infer<typeof updatePhoneAccessSchema>;

export interface PhoneAccessStatus {
  enforced: boolean;
  phone_numbers: string[];
  updated_at: string | null;
}

export type PhoneNumberProvider = 'twilio' | 'telnyx' | 'whatsapp';

export type PhoneUsageReferenceType =
  | 'configuration'
  | 'campaign'
  | 'workflow'
  | 'scheduled_message'
  | 'setting';

export interface PhoneUsageReference {
  type: PhoneUsageReferenceType;
  id: string;
  name: string;
  /** Which field/node holds the number, e.g. "inbound_twilio_phone_number_id". */
  field: string;
}

/** One number from this platform's inventory that something references. */
export interface PhoneUsageEntry {
  phone_number: string;
  providers: PhoneNumberProvider[];
  granted: boolean;
  references: PhoneUsageReference[];
}

export interface PhoneUsageResponse {
  enforced: boolean;
  numbers: PhoneUsageEntry[];
}
